import partnersAffiliateRepository from "@/repository/generatedRepository/partnersAffiliateRepository";
import moment from 'moment'
import { DATE_FORM_FORMAT } from '@/constants/date'
const { saveAs } = require('file-saver')

const actions = {
  async loadPartnerAffiliate(context, filters) {
    const { data } = await partnersAffiliateRepository.list(filters)
    return data
  },
  createPartnerAffiliate(context, payload) {
    return partnersAffiliateRepository.post(payload)
  },
  updatePartnerAffiliate(context, payload) {
    const { id, ...data } = payload
    return partnersAffiliateRepository.put(id, data)
  },
  deletePartnerAffiliate(context, payload) {
    return partnersAffiliateRepository.delete(payload)
  },
  async checkAffiliateUnique(context, payload) {
    const { data } = await partnersAffiliateRepository.checkUnique(payload)
    return data
  },
  async exportAffiliateDuplicates() {
    const response = await partnersAffiliateRepository.exportDuplicates({ responseType: 'blob' })
    const blob = new Blob([response.data], { type: response.headers['content-type'] })
    const filename = `affiliate_id_duplicates_${moment().format(DATE_FORM_FORMAT)}.csv`
    saveAs(blob, filename)
    return response
  },
}
export default {
  namespaced: true,
  actions,
}
